import { useEffect } from 'react';

// Scroll reveals: toggles the non-React `data-in` attribute on [data-reveal]
// elements as they enter the viewport. Transform-only (no opacity fade) so
// content stays readable even in headless/embedded contexts.
export default function useReveals(rootRef) {
  useEffect(() => {
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      const root = rootRef.current || document;
      const els = Array.prototype.slice.call(root.querySelectorAll('[data-reveal]'));
      els.forEach((el) => {
        el.style.transition = 'none';
        el.setAttribute('data-in', '1');
      });
      return () => {};
    }

    const root = rootRef.current || document;
    let els = Array.prototype.slice.call(root.querySelectorAll('[data-reveal]'));
    const timeouts = [];

    const check = () => {
      const vh = window.innerHeight || document.documentElement.clientHeight;
      let i = 0;
      els = els.filter((el) => {
        const r = el.getBoundingClientRect();
        if (r.top < vh * 0.9 && r.bottom > 0) {
          el.style.transitionDelay = Math.min(i * 70, 280) + 'ms';
          el.setAttribute('data-in', '1');
          i++;
          return false;
        }
        return true;
      });
      if (!els.length) {
        window.removeEventListener('scroll', check, true);
        window.removeEventListener('resize', check, true);
      }
    };

    window.addEventListener('scroll', check, true);
    window.addEventListener('resize', check, true);
    check();
    timeouts.push(setTimeout(check, 80));
    timeouts.push(setTimeout(check, 450));

    return () => {
      window.removeEventListener('scroll', check, true);
      window.removeEventListener('resize', check, true);
      timeouts.forEach(clearTimeout);
    };
  }, [rootRef]);
}
